// Site-wide interactions: hero stack, quote carousel, journal + FAQ filtering,
// before/after slider, gift-card preview, newsletter state.
(function () {
  /* hero card stack — click a card (or a dot) to bring it forward */
  document.querySelectorAll('[data-stackgroup]').forEach(function (stack) {
    var cards = Array.prototype.slice.call(stack.querySelectorAll('.stack__c'));
    var dots = stack.querySelector('[data-stackdots]');
    if (!cards.length) return;
    var base = cards.map(function (c) { return c.style.transform || getComputedStyle(c).transform; });
    if (dots) {
      cards.forEach(function (c, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Show card ' + (i + 1));
        b.setAttribute('aria-pressed', i === cards.length - 1 ? 'true' : 'false');
        b.addEventListener('click', function () { front(i); });
        dots.appendChild(b);
      });
    }
    function front(i) {
      cards.forEach(function (c, n) {
        c.style.zIndex = n === i ? 4 : 1;
        c.style.transform = n === i ? 'rotate(0deg) translateY(-10px)' : base[n];
      });
      if (dots) Array.prototype.forEach.call(dots.children, function (d, n) { d.setAttribute('aria-pressed', n === i ? 'true' : 'false'); });
    }
    cards.forEach(function (c, i) { c.addEventListener('click', function () { front(i); }); });
  });

  /* quote carousel */
  document.querySelectorAll('[data-quotes]').forEach(function (wrap) {
    var slides = Array.prototype.slice.call(wrap.querySelectorAll('.quotes__slide'));
    var dots = wrap.querySelector('[data-quotes-dots]');
    if (slides.length < 2) return;
    var i = 0, timer;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
      if (dots) Array.prototype.forEach.call(dots.children, function (d, k) { d.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
    }
    slides.forEach(function (_, k) {
      var b = document.createElement('button');
      b.type = 'button'; b.setAttribute('aria-label', 'Quote ' + (k + 1));
      b.addEventListener('click', function () { go(k); reset(); });
      if (dots) dots.appendChild(b);
    });
    wrap.querySelectorAll('[data-quote-dir]').forEach(function (b) {
      b.addEventListener('click', function () { go(i + (b.dataset.quoteDir === 'next' ? 1 : -1)); reset(); });
    });
    function reset() { clearInterval(timer); timer = setInterval(function () { go(i + 1); }, 7000); }
    go(0); reset();
    wrap.addEventListener('mouseenter', function () { clearInterval(timer); });
    wrap.addEventListener('mouseleave', reset);
  });

  /* text + tag filtering for journal and FAQ lists */
  document.querySelectorAll('[data-filterlist]').forEach(function (scope) {
    var items = Array.prototype.slice.call(scope.querySelectorAll('[data-fitem]'));
    var count = scope.querySelector('[data-fcount]');
    var search = scope.querySelector('[data-fsearch]');
    var tag = null;
    function apply() {
      var q = (search && search.value || '').trim().toLowerCase();
      var n = 0;
      items.forEach(function (el) {
        var hay = (el.textContent + ' ' + (el.dataset.tags || '')).toLowerCase();
        var ok = (!tag || (el.dataset.tags || '').toLowerCase().indexOf(tag.toLowerCase()) > -1) && (!q || hay.indexOf(q) > -1);
        el.classList.toggle('is-filtered-out', !ok);
        if (ok) n++;
      });
      if (count) count.textContent = n + (n === 1 ? ' result' : ' results');
      var none = scope.querySelector('[data-fempty]');
      if (none) none.hidden = n !== 0;
    }
    scope.querySelectorAll('[data-ftag]').forEach(function (b) {
      b.addEventListener('click', function () {
        tag = tag === b.dataset.ftag ? null : b.dataset.ftag;
        scope.querySelectorAll('[data-ftag]').forEach(function (o) { o.setAttribute('aria-pressed', o.dataset.ftag === tag ? 'true' : 'false'); });
        apply();
      });
    });
    if (search) search.addEventListener('input', apply);
    apply();
  });

  /* before / after slider */
  document.querySelectorAll('[data-ba]').forEach(function (el) {
    function set(e) {
      var r = el.getBoundingClientRect();
      var x = ((e.touches ? e.touches[0].clientX : e.clientX) - r.left) / r.width * 100;
      el.style.setProperty('--split', Math.max(2, Math.min(98, x)) + '%');
    }
    var drag = false;
    el.addEventListener('mousedown', function (e) { drag = true; set(e); });
    window.addEventListener('mouseup', function () { drag = false; });
    el.addEventListener('mousemove', function (e) { if (drag) set(e); });
    el.addEventListener('touchstart', set, { passive: true });
    el.addEventListener('touchmove', set, { passive: true });
  });

  /* gift-card amount preview */
  document.querySelectorAll('[data-gcpick]').forEach(function (scope) {
    var amt = scope.querySelector('[data-gc-amount]');
    var msg = scope.querySelector('[data-gc-msg]');
    var input = scope.querySelector('[data-gc-input]');
    var fallback = msg ? msg.textContent : '';
    scope.querySelectorAll('[data-gc-value]').forEach(function (b) {
      b.addEventListener('click', function () {
        scope.querySelectorAll('[data-gc-value]').forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        if (amt) amt.textContent = b.dataset.gcValue;
      });
    });
    if (input && msg) input.addEventListener('input', function () { msg.textContent = input.value.trim() || fallback; });
  });

  /* newsletter inline confirmation (no-JS forms still post normally) */
  document.querySelectorAll('.news form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (form.dataset.live === 'true') return;
      e.preventDefault();
      form.classList.add('is-done');
      var p = document.createElement('p');
      p.className = 'form-note';
      p.textContent = 'Thank you — the next letter posts on Sunday.';
      form.parentElement.appendChild(p);
    });
  });
})();
